import axios from 'axios';
import { APP_API_URL } from '../../utils';

export const CART_EDIT_KEY = 'asebat_cart_edit';

export async function stageOngoingSaleForCart(orderId) {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${APP_API_URL}/commandes/${orderId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const order = response.data?.data || response.data;
  if (order.statut_commande !== 'en cours') {
    const error = new Error('Seule une vente en cours peut être modifiée dans le panier.');
    error.code = 'not_pending';
    throw error;
  }
  const cart = (order.products || []).map(cartItemFromOrderLine).filter((row) => row.id);
  if (!cart.length) {
    const error = new Error('Cette commande ne contient aucun article à reprendre.');
    error.code = 'empty';
    throw error;
  }
  const customer = order.customer || {};
  sessionStorage.setItem(CART_EDIT_KEY, JSON.stringify({
    kind: 'sale',
    id: order.id,
    designation: order.designation,
    cart,
    customer,
    customerId: customer.id || order.customer_id,
    modeReglementId: order.mode_reglement?.id || null,
    remise: Number(order.remise) || 0,
    aibValue: order.aib_value || null,
    referencePiece: order.reference_piece || '',
    sendInvoiceByEmail: Boolean(order.send_invoice_by_email),
  }));
  return order;
}

export async function stageInstallmentForCart(orderId) {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${APP_API_URL}/installment-orders/${orderId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const order = response.data?.data || response.data;
  if (order.status === 'paid' || order.status === 'converted') {
    const error = new Error('Cette commande ne peut plus être modifiée dans la caisse.');
    error.code = 'not_pending';
    throw error;
  }
  const cart = (order.variants || []).map((line) => {
    const variant = line.variant || {};
    const product = variant.product || {};
    const reserved = Number(line.quantity) || 0;
    const stock = Number(variant.quantity) || 0;
    const price = Number(line.unit_price ?? variant.price) || 0;
    const sold = Number(line.modified_unit_selling_price ?? line.unit_price ?? price) || 0;
    return {
      ...variant,
      id: Number(variant.id || line.variant_id),
      name: variant.name || product.name || 'Produit',
      sku: variant.sku || '',
      price,
      quantity: reserved,
      initialQuantity: stock + reserved,
      customPrice: sold,
      is_taxable: variant.is_taxable !== false && variant.is_taxable !== 0,
      product,
      unit: product.unit?.name || product.unit?.symbol || '',
    };
  }).filter((row) => row.id);
  if (!cart.length) {
    const error = new Error('Cette commande ne contient aucun article à reprendre.');
    error.code = 'empty';
    throw error;
  }
  const customer = order.customer || {};
  sessionStorage.setItem(CART_EDIT_KEY, JSON.stringify({
    kind: 'installment',
    installmentOrderId: order.id,
    designation: order.designation,
    cart,
    customer,
    customerId: customer.id || order.customer_id,
    modeReglementId: order.mode_reglement_id || null,
    remise: Number(order.remise) || 0,
    aibValue: order.aib_value || null,
    referencePiece: order.reference_piece || '',
    useCustomerBalance: Number(customer.balance) > 0,
  }));
  return order;
}

export const PAYMENT_OPTIONS = [
  { label: 'Mobile Money', value: 1 },
  { label: 'Carte bancaire', value: 2 },
  { label: 'Virement', value: 3 },
  { label: 'Espèces', value: 4 },
  { label: 'Crédit', value: 5 },
  { label: 'Chèques', value: 7 },
  { label: 'Autre', value: 6 },
];

export const AIB_OPTIONS = [
  { label: 'AIB (0%)', value: null, emcf: null },
  { label: 'AIB (01%)', value: 0.01, emcf: 'A' },
  { label: 'AIB (05%)', value: 0.05, emcf: 'B' },
];

export function cartItemFromOrderLine(line) {
  const variant = line?.variant || {};
  const product = line?.product || variant.product || {};
  const price = Number(variant.price ?? line?.prix_unitaire_vente ?? line?.p1) || 0;
  const sold = line?.p2 != null && line.p2 !== '' ? Number(line.p2) : price;

  return {
    ...variant,
    id: Number(variant.id || line?.variant_id),
    name: variant.name || line?.name || product.name || 'Produit',
    sku: variant.sku || '',
    price,
    quantity: Number(line?.quantite) || 0,
    initialQuantity: Number(variant.quantity) || 0,
    customPrice: sold,
    is_taxable: line?.taxGroup ? line.taxGroup === 'B' : variant.is_taxable !== false && variant.is_taxable !== 0,
    product,
    unit: line?.unite || product.unit?.name || product.unit?.symbol || '',
  };
}

export function cartItemFromVariant(variant, line) {
  const price = Number(variant?.price) || 0;
  const sold = Number(line?.prix_unitaire ?? price);
  const name = String(line?.nom_produit || '');
  let isTaxable = variant?.is_taxable !== false && variant?.is_taxable !== 0;
  if (name.includes('(A)')) isTaxable = false;
  if (name.includes('(B)')) isTaxable = true;

  return {
    ...variant,
    quantity: Number(line?.quantite) || 0,
    initialQuantity: Number(variant?.quantity) || 0,
    customPrice: sold,
    is_taxable: isTaxable,
    unit: line?.unite || variant?.product?.unit?.name || '',
  };
}
